import { NavLink } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../hook/useAppSelector';
import { SidebarMenu } from '../../../../enum/SidebarMenu';
import { useAppDispatch } from '../../../../hook/useAppDispatch';
import { setActiveSidebarElement } from '../../../../store/slice/config/config';

interface Props {
  label: string;
  path: string;
  icon: string;
  sidebarMenuType: SidebarMenu;
  handleClose?: () => void;
}

const DirectNavLink: React.FC<Props> = ({ label, path, icon, sidebarMenuType, handleClose }) => {
  const activeSidebarElement = useAppSelector((state) => state.configSlice.activeSidebarElement);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <NavLink to={path}>
      <div
        onClick={() => {
          dispatch(setActiveSidebarElement(sidebarMenuType));
          handleClose && handleClose();
        }}
        className={`sidebar_element_wrapper ${activeSidebarElement === sidebarMenuType ? 'active' : ''}`}
      >
        <span>
          <img src={icon} alt="icon"></img>
          <p className="title">{t(`${label}`)}</p>
        </span>
      </div>
    </NavLink>
  );
};

export default DirectNavLink;
